export enum ApiProductPackage {
  CSP_PTC_BASE = 1,
  COLLECTOR_PACKAGE = 2,
  HCE_BASIC = 3,
  HCE_ADVANCED = 4,
  TORSION_PACKAGE = 5,
  CONCENTRATOR_GEOMETRY = 6,
  HCE_ALIGNMENT = 7,
  GLASS_BREAKAGE_PACKAGE = 8,
  BALL_JOINT_PACKAGE = 16,
  ONLINE_PERFORMANCE = 19,

  PV_BASE = 12,
  PV_THERMOGRAPHY_SURVEY_FULL_HD = 13,
  PV_THERMOGRAPHY_IEC62446 = 14,
  PV_SOILING = 15,
  PV_THERMOGRAPHY_SURVEY_4K = 17,
  DUMMY_PACKAGE = 18,
}
